<template>
  <div class="md:px-32 py-2 w-full">
    <div class="bg-blue-800 rounded-xl">
      <div class="shadow pt-1 border-b border-gray-200">
        <div class="bg-white border m-2 mt-1 inline flex rounded-xl">
          <button
            @click="value1(falso1)"
            class="
              bg-blue-500
              m-1
              p-1
              mx-2
              px-2
              font-bold
              text-white
              inline
              flex
              border-blue-100
              rounded
            "
          >
            <a href="#modalReferencias">
              <p>Agregar</p>
            </a>
          </button>

          <input
            class="border-2 m-1 p-1 w-full rounded-mb"
            v-model="buscar"
            @keyup="LoadProductos(buscar)"
            @keyup.delete="LoadProductos(buscar)"
            type="text"
            placeholder="   Buscar"
          />
          <button>
            <img
              class="p-1 mt-1 fill-current text-green-600"
              width="35px"
              height="20px"
              src="https://svgsilh.com/svg_v2/1093183.svg"
              alt="X"
            />
          </button>
        </div>
        <table
          class="ListaTabla header_fijo min-w-full uppercase bg-white"
          id="Topicos_Datatable"
        >
          <div class="grid grid-cols-4 bg-blue-800 text-white text-center">
            <th
              class="
                text-left
                px-4
                text-blue-800
                lg:text-white
                uppercase
                font-semibold
                text-sm
              "
            >
              ID
            </th>

            <th class="px-4 text-center px-4 uppercase font-semibold text-sm">
              codigo
            </th>
            <th class="text-center px-20 uppercase font-semibold text-sm">
              Descripcion
            </th>
            <th class="px-4 uppercase font-semibold text-sm"></th>
          </div>
          <tbody class="text-gray-700 divide-y-2 border rounded">
            <tr
              class="
                bg-gray-100
                grid grid-cols-4
                text-center
                border border-gray-200
                hover:bg-white
                divide divide-x divide-gray-200
              "
              :key="api.idreferencia"
              v-for="api in referencia"
            >
              <td class="text-left px-4">
                {{ api.idreferencia }}
              </td>
              <td class="text-center px-4">
                {{ api.codigoreferencia }}
              </td>
              <td class="text-center">
                {{ api.nombrereferencia }}
              </td>
              <td class="">
                <button
                  @click="datosmodal(api), value0(falso)"
                  class="
                    text-black
                    mt-2
                    p-1
                    hover:bg-blue-400
                    ring-2 ring-blue-500
                    rounded
                  "
                >
                  <a class="" href="#modalReferencias">
                    <img
                      width="15px"
                      src="https://image.flaticon.com/icons/png/512/61/61776.png"
                      alt=""
                    />
                  </a>
                </button>
                <button
                  @click="eliminardatos(api)"
                  class="
                    text-black
                    mt-2
                    p-1
                    mx-5
                    hover:bg-red-400
                    b
                    border-light-red-300
                    ring-2 ring-red-500
                    rounded
                  "
                >
                  <a href="#modaleliminar">
                    <img
                      width="15px"
                      src="https://image.flaticon.com/icons/png/128/748/748023.png"
                      alt=""
                    />
                  </a>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div id="modaleliminar" class="modal text-black">
      <div class="modal-contenido rounded-xl">
        <div class="uppercase inline">
          <div
            class="
              bg-gradient-to-r
              from-red-400
              to-red-700
              text
              grid grid-cols-2
              inline
              bold
              mt-15
            "
          >
            <p class="font-bold text-xs p-2">¿seguro que deseas eliminar?</p>
            <a
              class="font-bold text-xl hover:text-white text-right mx-2"
              href="#"
              >x</a
            >
            <hr />
            <hr />
          </div>
        </div>

        <div class="flex">
          <p class="border rounded font-bold m-2 p-1">{{ id }}</p>
          <p class="border rounded font-bold m-2 w-80 p-1">{{ descripcion }}</p>
          <button
            @click="recargar(id)"
            class="
              text-black
              mt-2
              m-2
              p-1
              mx-5
              hover:bg-red-400
              b
              border-light-red-300
              ring-2 ring-red-500
              rounded
            "
          >
            <a href="#">
              <img
                width="20px"
                src="https://image.flaticon.com/icons/png/128/748/748023.png"
                alt=""
              />
            </a>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import axios from "axios";
import { mapState, mapMutations } from "vuex";

export default {
  name: "tablaReferencias",
  data() {
    return {
      apis: "",
      elemento: "",
      aux2: [],
      buscar: "",
      falso: false,
      falso1: true,
      id: "",
      descripcion: "",
    };
  },
  computed: {
    ...mapState(["numero"]),
    ...mapState("referencias", ["referencia", "descripcionmodal"]),
  },

  methods: {
    datosEditar(api) {
      this.datosmodal(api);
    },

    eliminardatos(api) {
      (this.id = api.idreferencia), (this.descripcion = api.nombrereferencia);
    },

    async recargar(id) {
      await this.eliminar(id);
      setTimeout(() => {
        this.cargardatosreferencias();
      }, 500);
    },

    ...mapMutations(["value0", "value1"]),
    ...mapMutations("referencias", [
      "eliminar",
      "LoadProductos",
      "datosmodal",
      "cargardatosreferencias",
      "cambiarmensaje",
    ]),
  },
};
</script>
<style scoped >
.modal-contenido {
  background-color: rgb(255, 255, 255);
  width: 500px;
  height: auto;

  margin: auto;
  margin-top: 100px;
  position: relative;
}
.modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 0.1s;
}
#modaleliminar:target {
  opacity: 1;
  pointer-events: auto;
}

.header_fijo {
  width: 750px;
  table-layout: fixed;
  border-collapse: collapse;
}

.header_fijo thead tr {
  display: block;
  position: relative;
}
.header_fijo tbody {
  display: block;
  overflow: auto;
  width: 100%;
  height: 400px;
}
</style>